
const init = () => {

};

document.addEventListener('DOMContentLoaded', () => {
    init();
});